import { Backdrop, Box, Button, CircularProgress, Typography } from "@mui/material";

// Shared action button with a loading backdrop overlay — used for async actions
// (downloads, imports, confirmations) that need to block interaction while pending.
const LoadingActionButton = ({
  label,
  icon,
  loading = false,
  disabled,
  fontSize = 12,
  margin = 1,
  minWidth = 150,
  width = 150,
  height = 37,
  sx,
  ...rest
}) => {
  return (
    <>
      <Button
        variant="contained"
        size="small"
        disabled={disabled}
        sx={{
          margin,
          minWidth,
          width,
          height,
          ...sx,
        }}
        {...rest}
      >
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 0.5 }}>
          {icon}
          <Typography sx={{ fontSize }}>{label}</Typography>
        </Box>
      </Button>
      <Backdrop
        sx={{ zIndex: 10000 }}
        open={loading}
      >
        <CircularProgress
          color="primary"
          size={60}
        />
      </Backdrop>
    </>
  );
};

export default LoadingActionButton;
